/**
 * Interface for stylesheet arguments
 */
export interface IAddStylesheetArgs {
    id: string,
    css: string
}

/**
 * Adds or updates a stylesheet in the document head
 * @param args - Object containing id and css
 * @returns void
 */
export default function addStylesheet({
    id,
    css
}: IAddStylesheetArgs): void {
    try {
        if (!css || typeof css !== 'string') {
            console.warn('Invalid CSS provided to addStylesheet');
            return;
        }

        if (!id || typeof id !== 'string') {
            console.warn('Invalid ID provided to addStylesheet');
            return;
        }

        // Try to find existing stylesheet or create new one
        let styleElement = document.getElementById(id) as HTMLStyleElement;
        
        if (!styleElement) {
            styleElement = document.createElement('style');
            styleElement.id = id;
            document.head.appendChild(styleElement);
        }

        // Update the CSS content
        styleElement.innerHTML = css;
    } catch (error) {
        console.error('Failed to add stylesheet:', error);
    }
}